export default "__VITE_ASSET__UFWP3O74__"